import { axiosInstanceWithCredentials } from "./base";

export function getAchievements(params) {
    return axiosInstanceWithCredentials.get("/achievements", {
        params
    });
}
export function addAchievement(data) {
    return axiosInstanceWithCredentials.post(`/achievement/`,data);
}
export function getAchievement(id) {
    return axiosInstanceWithCredentials.get(`/achievement/${id}`);
}

export function updateAchievement(id,data) {
    return axiosInstanceWithCredentials.put(`/achievement/${id}`,data);
}

export function deleteAchievement(id) {
    return axiosInstanceWithCredentials.delete(`/achievement/${id}`);
}
